import axios from 'axios'
import qs from 'qs'
import mem from 'mem'
import _isEmpty from 'lodash-es/isEmpty'
import _upperCase from 'lodash-es/upperCase'
import _has from 'lodash-es/has'
import _keys from 'lodash-es/keys'
import _cloneDeep from 'lodash-es/cloneDeep'

import { useCMSYAUTHstore } from '@/service/stores/cm/cmsy/AUTH.store'

const RequestEnum = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  TEST: 'TEST'
}

const REFRESH_URL = import.meta.env.VITE_REFRESH_URL || ''
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || ''
const VITE_API_URL = import.meta.env.VITE_API_URL || ''

const axiosControllers = []

const headers_ = {
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8',
  'X-Requested-With': 'XMLHttpRequest'
}

export function cancelAxiosRequests() {
  const controllers = axiosControllers.splice(0)

  for (const controller of controllers) {
    controller.abort()
  }
}

const getRefreshToken = mem(
  async () => {
    const authStore = useCMSYAUTHstore()
    try {
      const accessToken_ = authStore?.authInfo?.accessToken || ''
      const refreshToken_ = authStore?.authInfo?.refreshToken || ''
      const url_ = VITE_API_URL + '' + REFRESH_URL

      const config = {
        timeout: 3600 * 1000,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${accessToken_}`
        },
        method: 'post',
        url: url_,
        data: {
          refreshToken: refreshToken_
        }
      }

      const { data } = await axios(config)
      console.debug('getRefreshToken data:', data)
      const { accessToken, refreshToken, secondAuthYn } = data.data
      console.debug('getRefreshToken accessToken:', accessToken)
      console.debug('getRefreshToken refreshToken:', refreshToken)
      console.debug('getRefreshToken secondAuthYn:', secondAuthYn)

      if (refreshToken !== null) {
        authStore.authInfo = {
          accessToken,
          refreshToken,
          secondAuthYn
        }
        authStore.actionSaveAuth()
      }

      return accessToken
    } catch (e) {
      authStore.actionLogout()
      window.location.href = '/dllg/DLLG-01-V101'
      return null
    }
  },
  { maxAge: 3000 }
)

export function setInterceptors(instance) {
  instance.interceptors.request.use(
    function (config) {
      const authStore = useCMSYAUTHstore()

      const accessToken = authStore?.authInfo?.accessToken || ''
      const refreshToken = authStore?.authInfo?.refreshToken || ''

      if (!_isEmpty(accessToken) && !_isEmpty(refreshToken)) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      const xSession = authStore.xSession || {}

      for (const xSessionKey in xSession) {
        const xSessionValue = xSession[xSessionKey]
        if (!_isEmpty(xSessionValue)) {
          config.headers[xSessionKey] =
            (xSessionKey === 'X-GSSM-STR-NM' || xSessionKey === 'X-GSSM-STR-SALE-TEAM-NM'
              ? encodeURIComponent(xSessionValue)
              : xSessionValue) || ''
        }
      }

      const XMENUID = localStorage.getItem('xMenuId') || ''

      config.headers['X-MENU-ID'] = XMENUID

      const controller = new AbortController()
      config.signal = controller.signal
      axiosControllers.push(controller)

      if (_upperCase(config.method) === 'POST' && _has(config.data, 'files')) {
        const formData = new FormData()
        const bodyData = config.data
        let nBodyData = {}
        for (const bodyProps of _keys(bodyData)) {
          if (bodyProps === 'files') {
            for (const fileObj of bodyData[bodyProps]) {
              if (fileObj instanceof File) {
                formData.append('file', fileObj)
              }
            }
          } else if (bodyProps === 'data') {
            nBodyData = _cloneDeep(bodyData[bodyProps])
          }
        }

        if (!_isEmpty(nBodyData)) {
          formData.append('data', JSON.stringify(nBodyData))
        }
        config.data = formData
        config.headers['Content-Type'] = 'multipart/form-data; charset=utf-8'
      }

      return config
    },
    async function (error) {
      return await Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    function (response) {
      const reqSignal = response.config.signal
      const reqControllerIdx = axiosControllers.findIndex((item) => item.signal === reqSignal)
      if (reqControllerIdx !== -1) {
        axiosControllers.splice(reqControllerIdx, 1)
      }

      // const cUrl = response.config.url?.split('/')
      let urlObj

      if (import.meta.env.MODE === 'loc' || import.meta.env.MODE === 'preview') {
        urlObj = new URL(import.meta.env.VITE_API_PASS_URL + response.config.url || '')
        if (urlObj.pathname === VITE_API_URL + LOGIN_URL) {
          const { meta, data } = response.data
          const authStore = useCMSYAUTHstore()
          if (meta.code === '0000') {
            authStore.authInfo.accessToken = data.accessToken
            authStore.authInfo.refreshToken = data.refreshToken
          }
        }
      } else {
        urlObj = new URL(response.config.url || '')

        console.debug('urlObj.pathname: ', urlObj.pathname)
        if (urlObj.pathname === LOGIN_URL) {
          const { meta, data } = response.data
          const authStore = useCMSYAUTHstore()
          if (meta.code === '0000') {
            authStore.authInfo.accessToken = data.accessToken
            authStore.authInfo.refreshToken = data.refreshToken
          }
        }
      }
      // console.debug('response.config: ', response.config)
      // console.debug('response.data: ', response.data)

      return response
    },
    async function (error) {
      const { config, response } = error

      console.debug(config)
      if (config.signal !== undefined) {
        const reqSignal = config.signal
        const reqControllerIdx = axiosControllers.findIndex((item) => item.signal === reqSignal)
        if (reqControllerIdx !== -1) {
          axiosControllers.splice(reqControllerIdx, 1)
        }
      }

      if (response == null) {
        return
      }
      const { status, data } = response

      if (config.url === REFRESH_URL || status !== 401 || config.sent) {
        // 에러가 났는데, 리프레시 토큰 요청이거나, 권한 문제가 아니거나, 새로운 리프레시 토큰으로 다시 전송한 업무 API 요청이라면
        // 즉 복구 불가능한 에러인 경우
        if ($loader.isShow()) {
          $loader.hide()
        }

        if (config.useCustomMsg === undefined && data.meta.msg) {
          await $msg.showMessage('type01', data.meta.msg.replace(/(?:\\r\\n|\\r|\\n|\n)/g, '<br />'))
        }

        return await Promise.reject(error)
      }

      if (status === 401 && data.meta.code === 'expired') {
        config.sent = true
        const accessToken = await getRefreshToken()
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`
          return await axios(config)
        }
      } else {
        if ($loader.isShow()) {
          $loader.hide()
        }
        return await Promise.reject(error)
      }
    }
  )
  return instance
}

// console.debug('import.meta.env : ', import.meta.env)

function createInstance(method_, timeout_) {
  const instance = axios.create({
    timeout: timeout_ || 300 * 1000,
    headers: headers_,
    method: method_,
    paramsSerializer: function (params) {
      return qs.stringify(params)
    }
    // withCredentials: true
    // baseURL: ''
  })
  return setInterceptors(instance)
}

export const axiosGet = createInstance(RequestEnum.GET)
export const axiosPost = createInstance(RequestEnum.POST)
export const axiosPut = createInstance(RequestEnum.PUT)
export const axiosDelete = createInstance(RequestEnum.DELETE)
